import FindFruit from "../../components/Nursery/EnvironmentScience/FindFruit";
import MatchFruit from "../../components/Nursery/EnvironmentScience/MatchFruit";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - Environment Science - Fruit"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/fruit/find-fruit", title: "Find Fruit", component: FindFruit},
    { url: "/nursery/environmental-science/fruit/match-fruit", title: "Match Fruit", component: MatchFruit},
];


export default topics;